import React from 'react';  
import { useState, useEffect } from "react";
import { useTable, useFilters, usePagination, useRowSelect } from 'react-table'
import UserService from "../services/user.service";
import {matchSorter} from 'match-sorter';
import { useNavigate } from "react-router-dom";
import { Card, Table as RBTable, Form, Button, Spinner, Badge, Offcanvas } from 'react-bootstrap';
 
 function Solicitudes(props) {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDetails, setShowDetails] = useState(false);
  const [detailsRow, setDetailsRow] = useState(null);
  const navigate = useNavigate();

  // Using useEffect to call the API once mounted and set the data
  
  useEffect(() => {
    (async () => {
      try {
       const result = await UserService.getStockNuban();
       if(result){
         console.log(result);
         const res = JSON.parse(result.data);
         setData(res.feedData);
         setLoading(false);
       }else{
        navigate(`${process.env.PUBLIC_URL}/login`, { state: { response: '' } });
      }
    } catch (e) {
      navigate(`${process.env.PUBLIC_URL}/login`, { state: { response: '' } });
      setLoading(false);
      //console.error(e);
    }
     })();
   }, []);


// (Removed GlobalFilter)

// Define a default UI for filtering
function DefaultColumnFilter({
  column: { filterValue, preFilteredRows, setFilter, id },
}) {
  const count = preFilteredRows.length

  return (
    <Form.Control
      size="sm"
      value={filterValue || ''}
      onChange={e => {
        setFilter(e.target.value || undefined)
      }}
      placeholder={`Filtrar (${count})`}
      className="mt-1"
      style={{ minWidth: (id === 'stock' || id === 'reservado' || id === 'disponible') ? 90 : undefined }}
      inputMode={(id === 'stock' || id === 'reservado' || id === 'disponible') ? 'numeric' : undefined}
      pattern={(id === 'stock' || id === 'reservado' || id === 'disponible') ? '[0-9]*' : undefined}
    />
  )
}

// This is a custom filter UI for selecting
// a unique option from a list
function SelectColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id },
}) {
  // Calculate the options for filtering
  // using the preFilteredRows
  const options = React.useMemo(() => {
    const options = new Set()
    preFilteredRows.forEach(row => {
      options.add(row.values[id])
    })
    return [...options.values()]
  }, [id, preFilteredRows])

  // Render a multi-select box
  return (
    <select
      value={filterValue}
      onChange={e => {
        setFilter(e.target.value || undefined)
      }}
    >
      <option value="">All</option>
      {options.map((option, i) => (
        <option key={i} value={option}>
          {option}
        </option>
      ))}
    </select>
  )
}

// This is a custom filter UI that uses a
// slider to set the filter value between a column's
// min and max values
function SliderColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id },
}) {
  // Calculate the min and max
  // using the preFilteredRows

  const [min, max] = React.useMemo(() => {
    let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
    let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
    preFilteredRows.forEach(row => {
      min = Math.min(row.values[id], min)
      max = Math.max(row.values[id], max)
    })
    return [min, max]
  }, [id, preFilteredRows])

  return (
    <>
      <input
        type="range"
        min={min}
        max={max}
        value={filterValue || min}
        onChange={e => {
          setFilter(parseInt(e.target.value, 10))
        }}
      />
      <button onClick={() => setFilter(undefined)}>Off</button>
    </>
  )
}

// This is a custom UI for our 'between' or number range
// filter. It uses two number boxes and filters rows to
// ones that have values between the two
function NumberRangeColumnFilter({
  column: { filterValue = [], preFilteredRows, setFilter, id },
}) {
  const [min, max] = React.useMemo(() => {
    let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
    let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
    preFilteredRows.forEach(row => {
      min = Math.min(row.values[id], min)
      max = Math.max(row.values[id], max)
    })
    return [min, max]
  }, [id, preFilteredRows])

  return (
    <div
      style={{
        display: 'flex',
      }}
    >
      <input
        value={filterValue[0] || ''}
        type="number"
        onChange={e => {
          const val = e.target.value
          setFilter((old = []) => [val ? parseInt(val, 10) : undefined, old[1]])
        }}
        placeholder={`Min (${min})`}
        style={{
          width: '70px',
          marginRight: '0.5rem',
        }}
      />
      to
      <input
        value={filterValue[1] || ''}
        type="number"
        onChange={e => {
          const val = e.target.value
          setFilter((old = []) => [old[0], val ? parseInt(val, 10) : undefined])
        }}
        placeholder={`Max (${max})`}
        style={{
          width: '70px',
          marginLeft: '0.5rem',
        }}
      />
    </div>
  )
}

  function fuzzyTextFilterFn(rows, id, filterValue) {
    return matchSorter(rows, filterValue, { keys: [row => row.values[id]] })
  }


  // Let the table remove the filter if the string is empty
  fuzzyTextFilterFn.autoRemove = val => !val
  

  // (Removed global filter)

  const columns = React.useMemo(
    () => [
      {
        Header: 'Codigo',
        accessor: 'coditm', // accessor is the "key" in the data
        filter: 'fuzzyText',
      },
      {
        Header: 'Descripcion',
        accessor: 'descripcion',
      },
      {
        Header: 'Stock',
        accessor: 'stock',
        Cell: ({ value }) => (
          <Badge bg="secondary">{value}</Badge>
        )
      },
      {
        Header: 'Reservado',
        accessor: 'reservado',
        Cell: ({ value }) => (
          <Badge bg="warning" text="dark">{value}</Badge>
        )
      },
      {
        Header: 'Disponible',
        accessor: (row) => {
          const s = parseFloat(row.stock) || 0;
          const r = parseFloat(row.reservado) || 0;
          return s - r;
        },
        id: 'disponible',
        Cell: ({ value }) => {
          const v = Number(value);
          const variant = v <= 0 ? 'danger' : v <= 10 ? 'warning' : 'success';
          return <Badge bg={variant}>{v}</Badge>;
        }
      },
      {
        Header: 'Acciones',
        id: 'acciones',
        disableFilters: true,
        Cell: ({ row }) => (
          <Button
            size="sm"
            variant="outline-primary"
            className="p-1"
            title="Ver detalles"
            onClick={() => { setDetailsRow(row.original); setShowDetails(true); }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
              <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8"/>
              <path d="M8 5.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"/>
            </svg>
          </Button>
        )
      },
     ],
     []
   )
 
   const tableScrollStyle = {
    overflowY: 'auto',
    maxHeight: '500px'
  };
  const numericCols = ['stock','reservado','disponible'];
  const centerCols = ['acciones'];


  const filterTypes = React.useMemo(
    () => ({
      // Add a new fuzzyTextFilterFn filter type.
      fuzzyText: fuzzyTextFilterFn,
      // Or, override the default text filter to use
      // "startWith"
      text: (rows, id, filterValue) => {
        return rows.filter(row => {
          const rowValue = row.values[id]
          return rowValue !== undefined
            ? String(rowValue)
                .toLowerCase()
                .startsWith(String(filterValue).toLowerCase())
            : true
        })
      },
    }),
    []
  )

  const defaultColumn = React.useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter,
    }),
    []
  )
  
   const {
     getTableProps,
     getTableBodyProps,
     headerGroups,
     rows,
     prepareRow,
     page, // Instead of using 'rows', we'll use page,
     // which has only the rows for the active page
 
     // The rest of these things are super handy, too ;)
     canPreviousPage,
     canNextPage,
     pageOptions,
     pageCount,
     gotoPage,
     nextPage,
     previousPage,
     setPageSize,
     selectedFlatRows,
     visibleColumns,
     state: { pageIndex, pageSize },
 

   } = useTable({ 
   columns,
   data,
   defaultColumn, // Be sure to pass the defaultColumn option
   filterTypes,
   },
   useFilters, // useFilters!
   usePagination,
   useRowSelect,
   )
 
   return (
    <div className="container-fluid py-3">
      <Card className="shadow-sm">
        <Card.Header className="d-flex align-items-center">
          <h5 className="mb-0">Stock / Solicitudes</h5>
        </Card.Header>
        <Card.Body className="p-0">
          {loading ? (
            <div className="d-flex justify-content-center align-items-center py-5">
              <Spinner animation="border" role="status" />
            </div>
          ) : (
            <>
              <div style={tableScrollStyle}>
                {page.length === 0 ? (
                  <div className="text-center text-muted py-5">No hay registros para mostrar.</div>
                ) : (
                  <div className="table-responsive">
                  <RBTable hover striped className="mb-0 align-middle" style={{ tableLayout: 'fixed', width: '100%' }} {...getTableProps()}>
                  <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                    {headerGroups.map(headerGroup => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map(column => (
                          <th
                            {...column.getHeaderProps()}
                            className={(numericCols.includes(column.id) ? 'text-end ' : centerCols.includes(column.id) ? 'text-center ' : '') + (column.id === 'descripcion' ? 'col-descripcion text-nowrap ' : '') + (centerCols.includes(column.id) ? 'text-nowrap ' : '')}
                            style={{
                              width: numericCols.includes(column.id) ? 110 : (column.id === 'coditm' ? 140 : (column.id === 'descripcion' ? 280 : (centerCols.includes(column.id) ? 100 : undefined))),
                              minWidth: column.id === 'descripcion' ? 240 : undefined,
                            }}
                          >
                            <div className="d-flex flex-column">
                              <span>{column.render('Header')}</span>
                              <div style={{ minHeight: 31 }}>
                                {column.canFilter ? column.render('Filter') : <div style={{ height: 31 }} />}
                              </div>
                            </div>
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody {...getTableBodyProps()}>
                    {page.map((row) => {
                      prepareRow(row);
                      return (
                        <tr {...row.getRowProps()}>
                          {row.cells.map(cell => (
                            <td
                              {...cell.getCellProps()}
                              className={(numericCols.includes(cell.column.id) ? 'text-end ' : centerCols.includes(cell.column.id) ? 'text-center ' : '') + (cell.column.id === 'descripcion' ? 'col-descripcion text-truncate' : '')}
                              style={{
                                width: numericCols.includes(cell.column.id) ? 110 : (cell.column.id === 'coditm' ? 140 : (cell.column.id === 'descripcion' ? 280 : (centerCols.includes(cell.column.id) ? 100 : undefined))),
                                minWidth: cell.column.id === 'descripcion' ? 240 : undefined,
                              }}
                              title={cell.column.id === 'descripcion' ? String(cell.value || '') : undefined}
                            >
                              {cell.render('Cell')}
                            </td>
                          ))}
                        </tr>
                      );
                    })}
                  </tbody>
                  </RBTable>
                  </div>
                )}
              </div>
              <div className="d-flex justify-content-between align-items-center p-3 gap-2 flex-wrap">
                <div className="d-flex align-items-center gap-2">
                  <Button variant="outline-secondary" size="sm" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                    {'<<'}
                  </Button>
                  <Button variant="outline-secondary" size="sm" onClick={() => previousPage()} disabled={!canPreviousPage}>
                    {'<'}
                  </Button>
                  <Button variant="outline-secondary" size="sm" onClick={() => nextPage()} disabled={!canNextPage}>
                    {'>'}
                  </Button>
                  <Button variant="outline-secondary" size="sm" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                    {'>>'}
                  </Button>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <span className="text-muted">Página <strong>{pageIndex + 1}</strong> de <strong>{pageOptions.length}</strong></span>
                  <Form.Control
                    size="sm"
                    style={{ width: 100 }}
                    type="number"
                    min={1}
                    value={pageIndex + 1}
                    onChange={(e) => {
                      const p = e.target.value ? Number(e.target.value) - 1 : 0;
                      gotoPage(p);
                    }}
                  />
                  <Form.Select
                    size="sm"
                    value={pageSize}
                    onChange={(e) => setPageSize(Number(e.target.value))}
                    style={{ width: 140 }}
                  >
                    {[10, 20, 30, 40, 50].map(ps => (
                      <option key={ps} value={ps}>Mostrar {ps}</option>
                    ))}
                  </Form.Select>
                </div>
              </div>
            </>
          )}
        </Card.Body>
      </Card>
      <Offcanvas show={showDetails} onHide={() => setShowDetails(false)} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Detalle del Ítem</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {detailsRow ? (
            <div className="d-flex flex-column gap-2">
              <div><strong>Código:</strong> {detailsRow.coditm}</div>
              <div><strong>Descripción:</strong> {detailsRow.descripcion}</div>
              <div><strong>Stock:</strong> {detailsRow.stock}</div>
              <div><strong>Reservado:</strong> {detailsRow.reservado}</div>
              <div>
                <strong>Disponible:</strong> { (parseFloat(detailsRow.stock||0) - parseFloat(detailsRow.reservado||0)) }
              </div>
            </div>
          ) : (
            <div className="text-muted">Sin datos</div>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}

 export default Solicitudes;
